import { createTheme, lighten, responsiveFontSizes } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    secondary: true;
    alternate: true;
  }
}

declare module "@mui/material/styles" {
  interface Components {
    MuiPickersOutlinedInput?: {
      defaultProps?: unknown;
      styleOverrides?: {
        root?: React.CSSProperties;
        notchedOutline?: React.CSSProperties;
      };
      variants?: unknown[];
    };
  }
}

const baseTheme = createTheme({
  palette: {
    text: {
      primary: "#000000",
    },
    primary: {
      main: "#00B6B9",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#ff8175",
      contrastText: "#FFFFFF",
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: "Plus Jakarta Sans, sans-serif",
    subtitle1: {
      color: "#6C7278",
    },
    subtitle2: {
      color: "#6C7278",
      fontSize: "14px",
    },
  },

  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        color: "primary",
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "8px",
        },
        outlined: ({ ownerState }) => ({
          ...(ownerState.color === "primary" && {
            "&:hover": {
              backgroundColor: "#E0F7F8",
            },
          }),
        }),
        contained: ({ ownerState }) => ({
          ...(ownerState.size === "small" && {
            height: "40px",
            fontSize: "0.875rem",
          }),
          ...(ownerState.size === "medium" && {
            height: "48px",
            borderRadius: "8px",
            fontSize: "1rem",
          }),
          ...(ownerState.color === "primary" && {
            "&:hover": {
              backgroundColor: "#26c0c3",
            },
          }),
        }),
      },
      variants: [
        {
          props: { variant: "secondary", size: "medium" },
          style: {
            color: "#fff",
            borderRadius: "8px",
            height: "48px",
            fontSize: "1rem",
            backgroundColor: "#FF8175",
            "&:hover": {
              backgroundColor: lighten("#FF8175", 0.1),
            },
          },
        },
        {
          props: { variant: "alternate", size: "medium" },
          style: {
            borderRadius: "8px",
            height: "48px",
            fontSize: "1rem",
            backgroundColor: "#FAFAFA",
            "&:hover": {
              backgroundColor: lighten("#8D8D8D", 0.8),
            },
          },
        },
      ],
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00B6B9",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#00B6B9",
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          subtitle1: "p",
          subtitle2: "p",
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(baseTheme);
